import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const nav = useNavigate();
  const { register } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    setBusy(true);
    try {
      await register(email, password, name);
      toast.success("Account created");
      nav("/word");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Registration failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto py-12" data-testid="register-page">
      <div className="text-xs uppercase tracking-[0.3em] text-[#78350F] mb-4">Create account</div>
      <h1 className="font-serif-display text-4xl text-stone-900 mb-10">Begin your library.</h1>
      <form onSubmit={submit} className="space-y-8">
        <div>
          <label className="block text-xs uppercase tracking-[0.2em] text-stone-500 mb-2">Name (optional)</label>
          <input value={name} onChange={(e) => setName(e.target.value)} data-testid="register-name"
            className="w-full bg-transparent border-b border-stone-300 focus:border-[#9A3B3B] focus:outline-none px-0 py-2 text-lg" />
        </div>
        <div>
          <label className="block text-xs uppercase tracking-[0.2em] text-stone-500 mb-2">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="register-email"
            className="w-full bg-transparent border-b border-stone-300 focus:border-[#9A3B3B] focus:outline-none px-0 py-2 text-lg" />
        </div>
        <div>
          <label className="block text-xs uppercase tracking-[0.2em] text-stone-500 mb-2">Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="register-password"
            className="w-full bg-transparent border-b border-stone-300 focus:border-[#9A3B3B] focus:outline-none px-0 py-2 text-lg" />
        </div>
        <button type="submit" disabled={busy} data-testid="register-submit"
          className="bg-[#9A3B3B] hover:bg-[#7F2F2F] text-white px-8 py-3 tracking-wide transition-colors disabled:opacity-60">
          {busy ? "Creating..." : "Create account"}
        </button>
      </form>
      <div className="mt-8 text-sm text-stone-600">
        Already have an account? <Link to="/login" className="text-[#9A3B3B] underline underline-offset-4" data-testid="to-login">Sign in</Link>
      </div>
    </div>
  );
}
